import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/app/(site)/vouchers/offer/[offerId]/OfferClient.tsx");
